import {
    CDN_MOBILE_ASSETS_DEV_URL,
    CDN_MOBILE_ASSETS_PROD_URL
} from '../../app/config';
import { Api } from '../../core/api';
import { injectTSDI } from '../../core/tsdi';

export interface PartialImageDto {
    bucketName?: string;
    objectKey?: string;
}

export interface ImageColor {
    r: number;
    g: number;
    b: number;
    alpha: number;
}

/** @see https://sharp.pixelplumbing.com/api-constructor */
export interface ImageEdits {
    /** @see https://sharp.pixelplumbing.com/api-resize */
    resize?: {
        width?: number;
        height?: number;
        fit?: 'inside' | 'cover' | 'contain' | 'fill' | 'outside';
        background?: ImageColor;
    };
    flatten?: {
        background: ImageColor;
    };
}

// No longer needed as we're using direct parameters
// type Params = Parameters<typeof getImage>;

/**
 * Encodes a UTF-8 string to base64, handling characters outside the Latin1 range.
 * This prevents the "InvalidCharacterError" from btoa when dealing with Unicode characters.
 */
function utf8ToBase64(str: string): string {
    // Encode the string as UTF-8 bytes
    const bytes = new TextEncoder().encode(str);
    // Convert bytes to a binary string
    const binString = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');
    // Encode to base64
    return btoa(binString);
}

export function getCdnImage(bucket?: string, key?: string, edits?: ImageEdits) {
    const { env } = injectTSDI(Api);
    const CDN_URL =
        env === 'dev' ? CDN_MOBILE_ASSETS_DEV_URL : CDN_MOBILE_ASSETS_PROD_URL;

    if (!bucket || !key) {
        return undefined;
    }

    return getImage(CDN_URL, bucket, key, edits);
}
export function getImage(
    cdn: string,
    bucket?: string,
    key?: string,
    edits?: ImageEdits
) {
    if (!bucket || !key) {
        return undefined;
    }

    const config = {
        bucket,
        key,
        edits
    };

    return `${cdn}/${utf8ToBase64(JSON.stringify(config))}`;
}
